import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-plane-loader',
  templateUrl: './plane-loader.component.html',
  styleUrl: './plane-loader.component.css',
  imports: [CommonModule, TranslateModule],
})
export class PlaneLoaderComponent {
  @Input() class: string = '';
  @Input() showLoading: boolean = true;
}
